import React from 'react';
import "./judgmentsAdd.css"
import JudgmentsInputs from './inputs/judgmentsInputs';

const JudgmentsAdd = (props) => {
    return ( 
        <>
            <div className="mainJudgmentsList">
                <h1 className="judgmentsTitle">Dodaj wyrok</h1>
                <JudgmentsInputs
                    banksList = {props.banksList}
                    actualJudgmentDate = {props.actualJudgmentDate}
                    actualJudgmentSignature = {props.actualJudgmentSignature}
                    actualJudgmentCourt = {props.actualJudgmentCourt}
                    actualJudgmentBank = {props.actualJudgmentBank}
                    actualJudgmentNote = {props.actualJudgmentNote}
                    handleActualJudgmentDateChange = {props.handleActualJudgmentDateChange}
                    handleActualJudgmentSignatureChange = {props.handleActualJudgmentSignatureChange}
                    handleActualJudgmentCourtChange = {props.handleActualJudgmentCourtChange}
                    handleActualJudgmentBankChange = {props.handleActualJudgmentBankChange}
                    handleActualJudgmentNoteChange = {props.handleActualJudgmentNoteChange}
                    handleAddJudgment = {props.handleAddJudgment}
                />
            </div>
        </>
     );
}
 
export default JudgmentsAdd;